import { listEmployeeRequests } from "../../../infrastructure/repository/request-repository";
import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import renderEmployeeDetailRequestList from "../../../infrastructure/renders/EmployeeDetailRequestList/render-employee-detail-request-list";

export default async function consultEmployeeRequests({
  employeeId,
  wrapped = false,
}) {
  renderEmployeeDetailRequestList({ isLoading: true, wrapped });
  const companyId = await findCompanyId();
  const { data: requests } = await listEmployeeRequests({
    companyId,
    category: "renting-benefit",
    employeeId,
  });
  renderEmployeeDetailRequestList({ requests, wrapped });
}
